import styled from 'styled-components';

import { sizeStyles, StyledSizeProps } from '../../styles';

type Props = StyledSizeProps;

export const ListRoot = styled.ul<Props>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: 0;

  ${({ $maxHeight }) => ($maxHeight ? 'overflow: auto;' : '')};

  ${sizeStyles}
`;
